// extracted by mini-css-extract-plugin
module.exports = {"background":"ourstory_background__3mbOo","story":"ourstory_story__MRepS","useflex":"ourstory_useflex__ceOCg","first":"ourstory_first__3PGAn","second":"ourstory_second__3zlPn"};